import { isNonEmptyNumber } from './validateMinMax'

export const getDiscountedPriceValue = ({
  price,
  discount,
  precision = 3,
}: {
  price: number
  discount?: number
  precision?: number
}) => {
  if (!isNonEmptyNumber(discount)) {
    return Number(price)
  }

  return Number(
    (Number(price) - (Number(price) * Number(discount)) / 100).toFixed(
      precision
    )
  )
}

export const calculateDiscountPercentage = (
  originalPrice?: number,
  currentPrice?: number
): number => {
  if (
    !isNonEmptyNumber(originalPrice) ||
    !isNonEmptyNumber(currentPrice) ||
    originalPrice === 0
  ) {
    return 0
  }

  const discountAmount = originalPrice! - currentPrice!
  const discountPercentage = (discountAmount / originalPrice!) * 100

  return Math.round(discountPercentage * 100) / 100
}

export const getPriceValueFromDiscountedPrice = ({
  price,
  discount,
  precision = 3,
}: {
  price: number
  discount?: number
  precision?: number
}) => {
  if (!isNonEmptyNumber(discount)) {
    return Number(price)
  }

  return Number(
    (Number(price) + (Number(price) * Number(discount)) / 100).toFixed(
      precision
    )
  )
}

export const calculateMarkupPercentage = (
  basePrice?: number,
  markedUpPrice?: number
): number => {
  if (
    !isNonEmptyNumber(basePrice) ||
    !isNonEmptyNumber(markedUpPrice) ||
    basePrice === 0
  ) {
    return 0
  }

  const markupAmount = markedUpPrice! - basePrice!
  const markupPercentage = (markupAmount / basePrice!) * 100

  return Math.round(markupPercentage * 100) / 100
}

export const calculateBuyerPrice = ({
  wholesalePrice,
  percentage,
  precision = 8,
}: {
  wholesalePrice: number
  percentage: number
  precision?: number
}) => {
  if (!isNonEmptyNumber(wholesalePrice) || !isNonEmptyNumber(percentage))
    return 0
  return parseFloat(
    (wholesalePrice + (wholesalePrice * percentage) / 100).toPrecision(
      precision
    )
  )
}
